import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credentials|Badge|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ShareCertMetricsBadging,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogsCredentialBadge';
export type SPCatalogsCredentialBadgeLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}TitleTab`;

export const spCatalogsCredentialBadgeLocs: LocDefs<SPCatalogsCredentialBadgeLocNames> = {
	SPCatalogsCredentialBadgeTitleSection: {
		defaultValue: 'Certmetrics Badge',
		description: 'Section title',
		displayPath: `${pathStart}Section title`,
		displayType: 'Title',
		legacyName: 'Share.CertmetricsBadging/Catalogs.Credentials.CMBadge.Title.Section',
		...sharedProperties,
	},
	SPCatalogsCredentialBadgeTitleTab: {
		defaultValue: 'Certmetrics Badging',
		description: 'Tab title',
		displayPath: `${pathStart}Tab title`,
		displayType: 'Title',
		legacyName: 'Share.CertmetricsBadging/Catalogs.Credentials.CMBadge.Title.Tab',
		...sharedProperties,
	},
};

export type SPCatalogsCredentialBadgeLocType = LocMap<SPCatalogsCredentialBadgeLocNames>;
